const faqs = [
  {
    question: "Does South Carolina have its own regional passport agency?",
    answer: "No — South Carolina does not have a regional passport agency within the state. The nearest regional passport agency is the Atlanta Passport Agency, approximately 3–5 hours from most South Carolina cities. Using a registered courier like Fast Passport Center is typically faster and eliminates the need for an in-person agency visit.",
  },
  {
    question: "How fast can I get a passport in South Carolina?",
    answer: "With Fast Passport Center's courier service, South Carolina travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in South Carolina?",
    answer: "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility — typically a post office, county clerk, or public library. Renewals for adults can usually be done by mail without an in-person visit.",
  },
  {
    question: "Which airport should I fly from for international travel from South Carolina?",
    answer: "Charleston International (CHS) and Greenville-Spartanburg (GSP) offer direct service to major hubs. Myrtle Beach (MYR) has seasonal international service. Many South Carolina residents also drive to Charlotte Douglas (CLT) in North Carolina or Hartsfield-Jackson Atlanta (ATL) in Georgia for the most direct international connections.",
  },
  {
    question: "Can cruise passengers from Charleston use a passport card instead of a passport book?",
    answer: "It depends on your itinerary. Passport cards are valid for cruises that depart from and return to the same U.S. port and only visit Canada, Mexico, Bermuda, and the Caribbean. However, a passport book is strongly recommended as it covers all travel scenarios including emergency medical evacuation or flight changes.",
  },
  {
    question: "Where is the best place to get a passport photo in South Carolina?",
    answer: "CVS, Walgreens, UPS Store, FedEx Office, and Walmart locations across South Carolina offer passport photo services. Most locations offer walk-in service. Always verify the photo meets State Department requirements before submitting.",
  },
];

export { faqs };

export default function SCFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            South Carolina Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the state of South Carolina.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-white rounded-lg border border-gray-200 overflow-hidden">
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}